import {
  INominacionMercadoSecundarioPost,
  INominacionMercadoSecundarioPut,
} from '../../core/interfaces/nominacion-mercado-secundario.interface';

export class GetNominacionOptionsAction {
  static readonly type = '[NominacionMercadoSecundario] Get Options';
  constructor(
    public payload: {
      contratoMercadoSecundarioUuid: string;
      puntoSalidaUuid?: string | null;
      demandaUuid?: string | null;
    }
  ) {}
}

export class GetNominacionesByContratoAction {
  static readonly type = '[NominacionMercadoSecundario] Get By Contrato';
  constructor(
    public payload: string | { contratoUuid: string; fecha?: string | null }
  ) {}
}

export class CreateNominacionAction {
  static readonly type = '[NominacionMercadoSecundario] Create';
  constructor(public payload: INominacionMercadoSecundarioPost) {}
}

export class UpdateNominacionAction {
  static readonly type = '[NominacionMercadoSecundario] Update';
  constructor(
    public payload: { uuid: string; data: INominacionMercadoSecundarioPut }
  ) {}
}

export class DeleteNominacionAction {
  static readonly type = '[NominacionMercadoSecundario] Delete';
  constructor(public payload: string) {}
}

export class ClearNominacionesAction {
  static readonly type = '[NominacionMercadoSecundario] Clear';
  constructor() {}
}
